__turbopack_context__.v({
  "blok-big-title": "CartNotification-module__ZRO5EW__blok-big-title",
  "blok-subtitle": "CartNotification-module__ZRO5EW__blok-subtitle",
  "blok-title": "CartNotification-module__ZRO5EW__blok-title",
  "cart-notification": "CartNotification-module__ZRO5EW__cart-notification",
  "cart-notification-error": "CartNotification-module__ZRO5EW__cart-notification-error",
  "cart-notification-info": "CartNotification-module__ZRO5EW__cart-notification-info",
  "icon": "CartNotification-module__ZRO5EW__icon",
  "message": "CartNotification-module__ZRO5EW__message",
  "resetButton": "CartNotification-module__ZRO5EW__resetButton",
});
